export const safetyContent = {
  title: "Mental Health & Crisis Safety Resources",
  intro: "While BizNearYou is a local work discovery platform, we care deeply about the personal well-being of our community members. Job seeking and economic transition can be incredibly stressful times.",
  emergency: {
    heading: "Urgent Help & Suicide Prevention Lifeline (U.S.)",
    text: "If you are thinking about suicide, self-harm, or feeling hopeless, please call or text the 988 Suicide & Crisis Lifeline. It is free, completely confidential, and available 24 hours a day, 7 days a week.",
    calls: [
      { label: "Call 988", href: "tel:988" },
      { label: "Text 988", href: "sms:988" },
      { label: "Open 988 Web Support", href: "https://988lifeline.org" }
    ]
  },
  global: {
    text: "Global Contacts: If you are located outside of the United States, please immediately search for your local emergency services or telephone crisis helpline (e.g. 111/999 in the UK, 112 in Europe, 000 in Australia)."
  },
  guidance: {
    text: "Additional Professional Guidance: If you are struggling with persistent employment anxiety, depression, or occupational stress, we strongly recommend reaching out to a certified psychologist, licensed therapist, or a state-funded career counseling/health support center."
  }
};
